<script setup lang="ts">
import { computed } from "vue";

import HospitalIcon from "@/components/HospitalIcon.vue";
import MunicipalIcon from "@/components/MunicipalIcon.vue";
import ProviderIcon from "@/components/ProviderIcon.vue";
import type { Organisation } from "@/types";

const { type, color = "#333333" } = defineProps<{
  type: Organisation["type"];
  color?: string;
}>();

const icon = computed(
  () =>
    ({
      provider: ProviderIcon,
      hospital: HospitalIcon,
      municipal: MunicipalIcon,
    })[type],
);
</script>

<template>
  <Component :is="icon" :color />
</template>
